import { render, staticRenderFns } from "./NumberplateForm.vue?vue&type=template&id=60f54991&scoped=true&"
import script from "./NumberplateForm.vue?vue&type=script&lang=ts&"
export * from "./NumberplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./NumberplateForm.vue?vue&type=style&index=0&id=60f54991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f54991",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VForm,VIcon,VTextField})
